module.exports = __webpack_public_path__ + "static/media/SignatureVector.a6f29d1a.jpg";